// short words a child can read off a label and type, none with three letters in a row of the
// alphabet (forwards, backwards or repeated), which platform's password strength check marks down
const WORDS = [
  'apple', 'banana', 'cactus', 'comet', 'dragon', 'falcon', 'garden', 'hammer', 'island', 'jungle',
  'koala', 'lemon', 'magnet', 'mango', 'monkey', 'nugget', 'orbit', 'otter', 'panda', 'parrot',
  'pickle', 'pirate', 'pixel', 'planet', 'puzzle', 'river', 'robot', 'rocket', 'saturn', 'shark',
  'tiger', 'tomato', 'tundra', 'turtle', 'violin', 'walrus', 'wizard', 'zebra',
];

// no 0 or 1, which look like the letters o and l
const DIGITS = '23456789';

const random = (count) => {
  const values = new Uint32Array(1);
  window.crypto.getRandomValues(values);
  return values[0] % count;
};

// a new temporary password, such as "rocketpanda47": two different words and two digits, all
// lowercase, which platform's password strength check passes
export default () => {
  const first = WORDS[random(WORDS.length)];
  const others = WORDS.filter(word => word !== first);
  const second = others[random(others.length)];
  return `${first}${second}${DIGITS[random(DIGITS.length)]}${DIGITS[random(DIGITS.length)]}`;
};
